import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppServerAPI, TabComponent } from '@sdbn/common';
import { GateKeepingCandidate } from '../../../../gate-keeping/gate-keeping.model';

@Component({
    selector: 'app-gate-keeper-control-find-element-dialog',
    templateUrl: './gkc-find-element-dialog.component.html',
    styleUrls: ['./gkc-find-element-dialog.component.scss'],
    standalone: false
})
export class GKCFindElementDialogComponent implements OnInit {

  candidates: Array<GateKeepingCandidate>;

  selectedCandidate: GateKeepingCandidate;

  mode: 'QUERY' | 'LPR' | 'QR' | 'NONE' = 'QUERY';

  constructor(
    public dialogRef: MatDialogRef<GKCFindElementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI
  ) { }

  ngOnInit(): void {

  }

  public close() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close(this.selectedCandidate);
  }

  public selectCandidate(candidate: GateKeepingCandidate) {
    this.selectedCandidate = candidate;
  }

  public handleSelection(candidates: Array<GateKeepingCandidate>) {
    this.candidates = candidates;
  }

  public handleTabChange(tab: TabComponent) {
    this.mode = tab.data;
  }

}
